import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function init_org_kotlincrypto_error_InvalidParameterException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.v3m_1);
}
var InvalidParameterExceptionClass;
function InvalidParameterException() {
  if (InvalidParameterExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      static w3m() {
        var $this = this.rd();
        init_org_kotlincrypto_error_InvalidParameterException($this);
        return $this;
      }
      static x3m(message) {
        var $this = this.n2(message);
        init_org_kotlincrypto_error_InvalidParameterException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'InvalidParameterException', $.w3m);
    InvalidParameterExceptionClass = $;
  }
  return InvalidParameterExceptionClass;
}
//region block: exports
export {
  InvalidParameterException as InvalidParameterException2mvcdeorw8u1i,
};
//endregion

//# sourceMappingURL=InvalidParameterException.mjs.map
